var _rect, _rect2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 20,
    viewBox: "0 0 32 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 31.5,
    height: 19.5,
    rx: 1.75,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 31.5,
    height: 19.5,
    rx: 1.75,
    stroke: "black",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9999 14.2497C15.0132 15.0813 13.7334 15.5833 12.3349 15.5833C9.21418 15.5833 6.68433 13.0835 6.68433 9.99999C6.68433 6.9164 9.21418 4.41666 12.3349 4.41666C13.7334 4.41666 15.0132 4.91867 15.9999 5.75027C16.9866 4.91867 18.2664 4.41666 19.665 4.41666C22.7857 4.41666 25.3155 6.9164 25.3155 9.99999C25.3155 13.0835 22.7857 15.5833 19.665 15.5833C18.2664 15.5833 16.9866 15.0813 15.9999 14.2497Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 14.2497C17.215 13.2256 17.9855 11.7017 17.9855 9.99999C17.9855 8.29827 17.215 6.77436 16 5.75027C16.9867 4.91867 18.2665 4.41666 19.665 4.41666C22.7857 4.41666 25.3156 6.9164 25.3156 9.99999C25.3156 13.0835 22.7857 15.5833 19.665 15.5833C18.2665 15.5833 16.9867 15.0813 16 14.2497Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9999 14.2496C17.215 13.2255 17.9855 11.7016 17.9855 9.99987C17.9855 8.29815 17.215 6.77424 15.9999 5.75015C14.7849 6.77424 14.0144 8.29815 14.0144 9.99987C14.0144 11.7016 14.7849 13.2255 15.9999 14.2496Z",
    fill: "#FF5E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.0de7930511f2ceda90b9b43276262fc6.svg";
export { ForwardRef as ReactComponent };